/**
 * 默认电机库
 *
 * ⚠️ 当前数据为「理论占位值」：
 *   T_rated = P / (2π × R / 60)  其中 R = 3000 r/min
 * 即假设电机额定功率全部转换为机械功率，扭矩-转速曲线退化为单点。
 *
 * 实际使用前必须从公司常用电机品牌（安川/W系列等）的样本数据库导入：
 * - 真实额定/峰值扭矩（曲线拐点）
 * - 真实额定/最高转速
 * - 转子惯量（用于惯量匹配校验）
 * - 是否带刹车选项 / 价格 / 货期
 *
 * 来源：现有桌面计算程序「电机参数快速选取」面板共 18 档（截图见文档）。
 * 详见 docs/03-电机选型工具设计.md §4.1。
 */
const RATED_SPEED_DEFAULT = 3000;
const TWO_PI = 2 * Math.PI;
/** 由功率反推额定扭矩 (N·m)，假设转速 = 3000 rpm */
function torqueFromPower(powerW, rpm = RATED_SPEED_DEFAULT) {
    return Number(((powerW * 60) / (TWO_PI * rpm)).toFixed(4));
}
/**
 * 默认 18 档电机
 *
 * price 字段为「国产中端通用伺服电机（不含驱动器，3000 rpm）市场参考价占位」，
 * 数量级估算自 1688 / 阿里巴巴 / 工控商城等公开渠道的中位报价。
 * ⚠️ 客户给出真实采购价后须整体替换。低功率档单瓦更贵、高功率档单瓦收敛到 ~2 元/W。
 */
export const DEFAULT_MOTOR_LIBRARY = [
    { power: 100, code: '100W', price: 500 },
    { power: 400, code: '400W', price: 900 },
    { power: 750, code: '750W', price: 1500 },
    { power: 1000, code: '1KW', price: 2000 },
    { power: 1200, code: '1.2KW', price: 2400 },
    { power: 1300, code: '1.3KW', price: 2600 },
    { power: 1500, code: '1.5KW', price: 2900 },
    { power: 1800, code: '1.8KW', price: 3400 },
    { power: 2000, code: '2KW', price: 3800 },
    { power: 2300, code: '2.3KW', price: 4400 },
    { power: 2600, code: '2.6KW', price: 4900 },
    { power: 3000, code: '3KW', price: 5500 },
    { power: 3800, code: '3.8KW', price: 6800 },
    { power: 4400, code: '4.4KW', price: 7800 },
    { power: 5500, code: '5.5KW', price: 9500 },
    { power: 7500, code: '7.5KW', price: 13000 },
    { power: 11000, code: '11KW', price: 19000 },
    { power: 15000, code: '15KW', price: 26000 },
].map(({ power, code, price }) => ({
    id: `default-${code}`,
    brand: 'NMS',
    series: 'GENERIC',
    // 占位通用电机无真实型号；用 GENERIC-${code} 维持业务字段必填
    model: `GENERIC-${code}`,
    power,
    ratedTorque: torqueFromPower(power),
    ratedSpeed: RATED_SPEED_DEFAULT,
    hasBrakeOption: true,
    cpqMotorBrandCode: 'W',
    cpqMotorPowerCode: code,
    price,
}));
//# sourceMappingURL=motor-library.js.map